import { render, staticRenderFns } from "./costs.vue?vue&type=template&id=653d535a&"
import script from "./costs.vue?vue&type=script&lang=js&"
export * from "./costs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports